<template>
  <div>
    <SelectTypeComponent v-if="models?.importVersion" :model="models.importVersion" @update="updateField()" />
    <div v-if="models?.importVersion?.vars?.value?.attr" class="info">
      <div v-if="models?.importVersion?.vars?.value.attr['data-value']" class="info__item fw-bold">
        <span class="mb-2">
          {{
            models?.importVersion?.vars?.value.attr["data-label"]
              ? models.importVersion.vars.value.attr["data-label"]
              : ""
          }}
        </span>
        <span>
          {{
            models?.importVersion?.vars?.value.attr["data-value"]
              ? stringManager().formatCurrency(models.importVersion.vars.value.attr["data-value"])
              : ""
          }}
        </span>
      </div>
      <div v-if="training?.titleRncp" class="info__item">
        <span class="mb-2">{{ $t("registration.titleRncp") }} : </span>
        <span>
          {{ training.titleRncp ? training.titleRncp.code + " - " + training.titleRncp.name : "" }}
        </span>
      </div>
    </div>
  </div>
  <div v-if="models?.importVersion?.vars?.value" class="convention">
    <h2 class="form__title textStyle">{{ $t("registration.training_info.search_by_branch") }}</h2>
    <SelectTypeComponent v-if="models?.branch" :model="models.branch" @update="updateField(true)" />
  </div>
  <div v-if="cpneList && Object.keys(cpneList).length && models?.importVersion?.vars?.value" class="mt-4">
    <AlertBlock
      :text="$t('registration.training_info.only_different_cost_displayed')"
      type="primary"
      icon="circle-info"
    />
    <SortTableComponent
      :columns="columns"
      :datas="cpneList.data"
      :maxResult="cpneList.count"
      :apiFilters="false"
      :showFilter="false"
    />
  </div>
</template>

<script>
import AlertBlock from "@/components/blocks/AlertBlock.vue";
import SelectTypeComponent from "@/components/form/SelectTypeComponent.vue";
import SortTableComponent from "@/components/table/sortTable/SortTableComponent.vue";
import { dateFormatter } from "@/services/utilities/date-formatter";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";
import { stringManager } from "@/services/utilities/string-manager";

export default {
  name: "TrainingNpecComponent",
  components: { AlertBlock, SortTableComponent, SelectTypeComponent },
  props: {
    models: {
      type: Object,
      required: true,
      default: () => {},
    },
    cpneList: {
      type: Object,
      required: true,
      default: () => {},
    },
    training: {
      type: Object,
      required: true,
    },
  },
  emits: ["updateField"],
  data() {
    return {
      columns: [],
      data: [],
    };
  },
  watch: {
    cpneList() {
      this.getColumns();
    },
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    stringManager() {
      return stringManager;
    },
    getColumns() {
      this.columns = sortableTableManager.getEntriesColumns(this.cpneList.columns);
    },

    formatDate(date) {
      return dateFormatter.format(date, "short");
    },

    updateField(branch = false) {
      let params = {
        importVersion: this.models?.importVersion?.vars?.value?.value,
      };

      if (branch) {
        if (this.models?.branch?.vars?.value?.value) {
          params["branch"] = this.models?.branch?.vars?.value?.value;
        }
      }
      this.$emit("updateField", params);
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  &__title {
    margin-bottom: 20px;
  }
}

.info {
  display: flex;
  gap: 20px;
  margin-top: 25px;
  &__item {
    width: 100%;
    padding: 20px;
    border-radius: 6px;
    background-color: $m-color_2;
  }
}

.convention {
  border-top: 1px dashed #888ea8;
  margin-top: 25px;
  padding-top: 20px;
}
</style>
